import { render, staticRenderFns } from "./ModalFormBuilderColumn.vue?vue&type=template&id=4a730277&"
import script from "./ModalFormBuilderColumn.vue?vue&type=script&lang=js&"
export * from "./ModalFormBuilderColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports